import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Globe, MapPin, Facebook, Instagram, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="text-2xl font-bold mb-4">
              <span className="text-amber-500">Art</span>
              <span className="text-white">eğitim</span>
            </div>
            <p className="text-sm mb-4">
              Çekya'da eğitim hayallerinizi gerçeğe dönüştürmek için profesyonel danışmanlık hizmeti sunuyoruz.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center hover:bg-amber-600 transition-colors">
                <Facebook size={18} />
              </a>
              <a href="#" className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center hover:bg-amber-600 transition-colors">
                <Instagram size={18} />
              </a>
              <a href="#" className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center hover:bg-amber-600 transition-colors">
                <Linkedin size={18} />
              </a>
              <a href="#" className="w-9 h-9 bg-gray-800 rounded-full flex items-center justify-center hover:bg-amber-600 transition-colors">
                <Twitter size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Hızlı Bağlantılar</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-amber-500 transition-colors">Ana Sayfa</Link></li>
              <li><Link to="/hizmetler" className="hover:text-amber-500 transition-colors">Hizmetlerimiz</Link></li>
              <li><Link to="/universiteler" className="hover:text-amber-500 transition-colors">Üniversiteler</Link></li>
              <li><Link to="/yurtlar" className="hover:text-amber-500 transition-colors">Öğrenci Yurtları</Link></li>
              <li><Link to="/basvuru-sureci" className="hover:text-amber-500 transition-colors">Başvuru Süreci</Link></li>
              <li><Link to="/blog" className="hover:text-amber-500 transition-colors">Blog</Link></li>
              <li><Link to="/iletisim" className="hover:text-amber-500 transition-colors">İletişim</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Hizmetlerimiz</h3>
            <ul className="space-y-2 text-sm">
              <li className="hover:text-amber-500 transition-colors cursor-pointer">Dil Kursu Danışmanlığı</li>
              <li className="hover:text-amber-500 transition-colors cursor-pointer">Lisans Başvuruları</li>
              <li className="hover:text-amber-500 transition-colors cursor-pointer">Yüksek Lisans Başvuruları</li>
              <li className="hover:text-amber-500 transition-colors cursor-pointer">Vize Danışmanlığı</li>
              <li className="hover:text-amber-500 transition-colors cursor-pointer">Konaklama Desteği</li>
              <li className="hover:text-amber-500 transition-colors cursor-pointer">Havalimanı Karşılama</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">İletişim</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPin size={18} className="text-amber-500 mt-0.5 flex-shrink-0" />
                <span>Prag, Çek Cumhuriyeti</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={18} className="text-amber-500 flex-shrink-0" />
                <a href="tel:+420774668988" className="hover:text-amber-500 transition-colors">
                  +420 774 668 988
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={18} className="text-amber-500 flex-shrink-0" />
                <a href="mailto:artyurtdisiegitim@gmail.com" className="hover:text-amber-500 transition-colors break-all">
                  artyurtdisiegitim@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Globe size={18} className="text-amber-500 flex-shrink-0" />
                <a href="https://artyurtdisidanismanlik.com" className="hover:text-amber-500 transition-colors">
                  artyurtdisidanismanlik.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm">
          <p>&copy; 2024 Arteğitim Danışmanlık. Tüm hakları saklıdır.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;